import React from "react";
import image from '../jackie.jpg';

export default function Home(){
    return (
        <main>
            <img
                src={image}
                alt="Jackie_Picture"
                className="absolute object-cover w-full h-full"/>
            <section className="relative flex justify-center min-h-screen pt-12 lg:pt-64 px-8">
                <h1 className="test-6xl text-black-100 font-bold cursive leading-none lg:leading-snug home-name">Hello! I'm Jackie</h1>
            </section>
        </main>
    )
}